export const isDefined = <T>(value: T): value is Exclude<T, void | undefined> =>
  value !== undefined;

export const isNotNull = <T>(value: T | null): value is Exclude<T, null> => value !== null;
